import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { lazy } from "react";

const Index = lazy(() => import("@/pages/Index"));

const RootRoute = () => {
  const { loading, session, user, profile } = useAuth();

  const isAgency = !!profile?.agency_id || user?.user_metadata?.account_type === "agency" || user?.user_metadata?.account_type === "team_member";

  const isWaiting = loading || (!!session && !profile);

  if (isWaiting) {
    return null;
  }

  if (!session) {
    return <Index />;
  }

  if (user && !user.email_confirmed_at) {
    return <Navigate to={`/verify-email?email=${encodeURIComponent(user.email || "")}`} replace />;
  }

  if (!profile?.onboarding_done) {
    return <Navigate to={isAgency ? "/agency/onboarding" : "/onboarding"} replace />;
  }

  return <Navigate to={isAgency ? "/agency/inbox" : "/inbox"} replace />;
};

export default RootRoute;
